import { _elements } from './_elements';
import { _fade } from './_fade';

export const _navigator = ( navigator = null, callback ) => {

	if ( ! navigator ) {
		return;
	}

	const sliderId = navigator.getAttribute( 'data-navigator' );
	const slider = document.querySelector( `[data-slider="${ sliderId }"]` );
	const buttons = navigator.querySelectorAll( '[data-navigator-button]' );

	const {
		items,
	} = _elements( slider );

	buttons.forEach( ( button, i ) =>
		button.addEventListener( 'click', () => {
			_fade( slider, i );
			callback();

			// buttons.forEach( ( currentButton ) =>
			// 	button !== currentButton ? currentButton.classList.remove( 'is-active' ) : currentButton.classList.add( 'is-active' )
			// );
		} )
	);
};
